import JSONParser from '@core/scripts/helper/json-parser';
import Landmark from '@core/scripts/components/landmark-adapter';
import {emailFormatValidator} from '@core/scripts/helper/validation/email-validator';
import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';
import JshModule from '@core/scripts/helper/jsh-module';

const iconSpriteUrl = window.__BONPRIX_DESY_CONFIG__?.iconSprite || '/bff_resources/icon-sprite.svg';

const {moduleScope} = JshModule('footer/newsletter');
const submitButtonNode = moduleScope.querySelector('[jsh-newsletter__submit]');
const submitButtonWrapperNode = moduleScope.querySelector('[jsh-newsletter__button-wrapper]');

const inputGroupNode = moduleScope.querySelector('[jsh-input__wrapper]');
const inputFieldNode = moduleScope.querySelector('[jsh-input]');
const landmark = JSONParser.tryParseJSON(submitButtonWrapperNode.getAttribute('jsh-newsletter__button-wrapper'));

const successTextsNode = moduleScope.querySelector('.newsletter__success-texts');
const firmFieldNode = moduleScope.querySelector('#nl-website');
const errorSpanNode = moduleScope.querySelector('.input-group__error');
const originalErrorText = errorSpanNode ? errorSpanNode.textContent : '';
const validateEmail = emailFormatValidator();

const givePermissionUrl = successTextsNode?.dataset.subscribeUrl || '/service/newsletter/__subscribe-footer/';

submitButtonNode.disabled = true;

submitButtonNode.addEventListener('click', submitNewsletterSignUp);
inputFieldNode.addEventListener('input', handleInputChange);

function submitNewsletterSignUp(event) {
    event.preventDefault();
    const inputValue = inputFieldNode.value;
    if (validateEmail(inputValue)) {
        Landmark.sendLandmark(landmark);
        submitButtonNode.disabled = true;

        fetchWithCSRF(Url.toAbsolute(givePermissionUrl), {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
                email: inputValue,
                website: firmFieldNode ? firmFieldNode.value : '',
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Newsletter subscription failed with status: ${response.status}`);
                }
                inputFieldNode.value = '';
                showSuccessLayer();
            })
            .catch((error) => {
                const serverErrorText = successTextsNode?.dataset.serverErrorText;
                if (errorSpanNode && serverErrorText) {
                    errorSpanNode.textContent = serverErrorText;
                }
                inputGroupNode.classList.add('is-error');
            })
            .finally(() => {
                submitButtonNode.disabled = inputFieldNode.value.trim() === '';
            });
    } else {
        inputGroupNode.classList.add('is-error');
    }
}

function handleInputChange() {
    inputGroupNode.classList.remove('is-error');
    if (errorSpanNode) {
        errorSpanNode.textContent = originalErrorText;
    }
    submitButtonNode.disabled = inputFieldNode.value.trim() === '';
}

function resetErrorHandling() {
    inputGroupNode.classList.remove('is-error');
}

function showSuccessLayer() {
    moduleScope.hidden = true;
    const newsletterWrapper = moduleScope.previousElementSibling;
    if (newsletterWrapper?.classList.contains('newsletter__wrapper')) {
        newsletterWrapper.hidden = true;
    }

    const texts = successTextsNode ? {
        headlineText: successTextsNode.dataset.headline || '',
        newsletterLayerSuccessText: successTextsNode.dataset.successText || '',
        newsletterLayerSuccessMail: successTextsNode.dataset.successMail || '',
        newsletterLayerSuccessDiscount: successTextsNode.dataset.successDiscount || '',
        closeButtonAriaLabel: successTextsNode.dataset.closeLabel || 'Close'
    } : {};
    const existingLayer = document.getElementById('footer-newsletter-success-layer');
    if (existingLayer) {
        requestAnimationFrame(() => {
            existingLayer.classList.add('newsletter-layer__expanded');
        });
        return;
    }

    const layer = document.createElement('div');
    layer.id = 'footer-newsletter-success-layer';
    layer.className = 'newsletter-layer newsletter-layer__expanded newsletter-footer';

    layer.innerHTML = `
        <div class="newsletter-layer__content-wrapper">
            <div class="line-first-order300"></div>
            <div class="newsletter-layer__content">
                <div class="newsletter-layer__title-section newsletter-layer__title">
                    <h2>${texts.headlineText || ''}</h2>
                </div>
                <div class="newsletter-layer__step-section newsletter-layer__content-position">
                    <div class="newsletter-layer__text-section">
                        ${texts.newsletterLayerSuccessText || ''}
                    </div>
                    <div class="newsletter-layer__step">
                        <div class="newsletter-layer__step-icon">
                             <svg viewBox="0 0 24 24" width="24" height="24"><use href="${iconSpriteUrl}#newsletter-icon"></use></svg>
                        </div>
                        <div class="newsletter-layer__step-text">
                            ${texts.newsletterLayerSuccessMail || ''}
                        </div>
                    </div>
                    <div class="newsletter-layer__step">
                        <div class="newsletter-layer__step-icon">
                              <svg viewBox="0 0 24 24" width="24" height="24"><use href="${iconSpriteUrl}#discount-icon"></use></svg>
                        </div>
                        <div class="newsletter-layer__step-text">
                            ${texts.newsletterLayerSuccessDiscount || ''}
                        </div>
                    </div>
                </div>
                <div class="newsletter-layer__closer">
                    <button type="button" aria-label="${texts.closeButtonAriaLabel || 'Close'}" class="newsletter-layer__close-button">
                            <svg viewBox="0 0 24 24" width="24" height="24"><use href="${iconSpriteUrl}#closer-icon"></use></svg>
                    </button>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(layer);

    layer.querySelector('.newsletter-layer__close-button').addEventListener('click', () => {
        layer.classList.remove('newsletter-layer__expanded');
    });

    document.addEventListener('click', (event) => {
        if (layer.classList.contains('newsletter-layer__expanded') && !event.target.closest('.newsletter-layer__content-wrapper')) {
            layer.classList.remove('newsletter-layer__expanded');
        }
    });
}

